module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAAXNSR0IArs4c6QAAAQ1JREFUKFON0D1LA0EQBuD3TQRRJEQQewPemdKgWCsIapNK8OPk1v/gv7C0S3VH9izS+1UJNkrASgU3KUxvlc6YuCMXjIhyslPOvA87O0RGHbbrFWt5BbJd4PTqyfxWbxRlFgqNPiewmc7FDpbisrr/FylzugDaRwjyw6DNz0Xl3U4m2n5qTE2O9W4ILg5fAV5iPyj93OjPesroJoDlUUgEtwQa34i5DlVLdyEogOxG3n5RGS1Z//zqvzE0+pXATNqI/IAO6IHKJAYQzxUJpEZl6ncAV1wRgZ0UXQDccEEiGPQnOJseIoFgzwkB17EfrDF8To5JOQLwHvnBuGrpS4isA8z9uuKHUKqxd3D2CWnXb1mfKKKBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/statics/up.png
// module id = Je4j
// module chunks = 1